import ReactGA4 from 'react-ga4';
import { queryKeys } from 'src/consts/query.consts';
import { UserInfoResponse } from 'src/types/userData.types';
import queryClient from './queryClient.service';
import { getUserEnvSelector } from 'src/utils/userData.utils';

const getConfig = () => window.config;

export interface GaObject {
  eventName: string;
  payload?: Record<string, any>;
}

export const initGA4 = () => {
  ReactGA4.initialize([
    {
      trackingId: getConfig().google_analytics4_tracking_id,
    },
  ]);
};

export const fireGA4Event = async (eventName: string, eventPayload: Record<string, any>) => {
  const userInfoResponse = (await queryClient.getQueriesData([queryKeys.userInfo])) as any[];

  try {
    const userData = userInfoResponse?.[0]?.[1]?.['data'] || {};
    const { organization_details, user_data } = userData;

    ReactGA4.event(eventName, {
      orgId: organization_details?.id,
      environment: getUserEnvSelector(userData),
      userId: user_data?.id,
      ...eventPayload,
    });
  } catch (error) {}
};

export const initFullstory = ({ user_data, organization_details }: UserInfoResponse) => {
  if (user_data.id && window.FS) {
    window.FS.identify(user_data.id, {
      email: user_data.email,
      merchantName: organization_details.alias,
      signUpCountry: organization_details.signup_country_code,
      rapydEntity: organization_details.rapyd_entity,
      organizationStatus: organization_details.role,
      organizationId: user_data.org_id,
    });
  }
};

export const fireFullstoryEvent = (eventName: string, eventPayload: any) => {
  window.FS?.event(eventName, eventPayload);
};
